/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import {
  HashRouter as Router,
  Link,
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom'
import AccidentDebug from '../../../development/AccidentDebug'
import BaggageDebug from '../../../development/BaggageDebug'
import OtherDataDebug from '../../../development/OtherDataDebug'
import CancellationDebug from '../../../development/CancellationDebug'
import ClaimantDebug from '../../../development/ClaimantDebug'
import { FormikDebug } from '../../../development/FormikDebug'
import HealthProblemDebug from '../../../development/HealthProblemDebug'
import InsuranceDebug from '../../../development/InsuranceDebug'
import LiabilityDebug from '../../../development/LiabilityDebug'
import { TestForm } from '../../../development/TestPageForComponents'
import TicketDebug from '../../../development/TicketDebug'
import ThankYouPageDebug from '../../../development/ThankYouPageDebug'
import CancellationExpensesDebug from '../../../development/CancellationExpensesDebug'
import TreatmentExpensesDebug from '../../../development/TreatmentExpensesDebug'
import TripDebug from '../../../development/TripDebug'
import { isDEV } from '../../../helpers'
import useCaseType from '../../../hooks/useCaseType'
import { CaseTypeEnum, CaseTypeType } from '../../../models/caseReport'
import ErrorPage from '../../../pages/404'
import Accident from '../../../pages/Accident'
import Baggage from '../../../pages/Baggage'
import OtherDataPage from '../../../pages/OtherDataPage'
import CancellationPage from '../../../pages/CancellationPage'
import ClaimantPage from '../../../pages/ClaimantPage'
import HealthProblemPage from '../../../pages/HealthProblemPage'
import Home from '../../../pages/Home'
import { Insurance } from '../../../pages/Insurance'
import Liability from '../../../pages/Liability'
import Overview from '../../../pages/Overview'
import ThankYou from '../../../pages/ThankYou'
import Ticket from '../../../pages/Ticket'
import CancellationExpensesPage from '../../../pages/CancellationExpensesPage'
import TreatmentExpenses from '../../../pages/TreatmentExpenses'
import PublicRoute from '../PublicRoute'
import FrontInitPage from '../../../pages/FrontInitPage'
import { ColplAppLayout } from '../../../components/layout/ColplAppLayout'
import { useColplRouting } from './routes'
import RouteNextVersion, { RouteNextProps } from '../RouteNextVersion'
import { useClaimant } from '../../../context/col'
import * as _ from 'lodash'
import { useTreatmentExpensesProvider } from '../../../context/TreatmentExpensesContext'
import useCaseReportIsPresent from '../../../hooks/useCaseReportIsPresent'
import { ColplAppSimpleTitleBar } from '../../../components/layout/ColplAppSimpleTitleBar'
import { useTranslation } from 'react-i18next'
import { NavBarItem } from '../../../components/NavBar'
import { toMap } from '../../../helpers/groupBy'
import TripPage from '../../../pages/TripPage'
import { useGa4Context } from '../../../context/Ga4Context'
import useGa4 from '../../../hooks/useGa4'

const isDebugRoutesEnabled = isDEV

/**
 * Main App that starts with <Router> definition.
 *
 */
export const RouterApp = () => {
  return (
    <Router>
      <RoutedApp />
    </Router>
  )
}

const RoutedApp = () => {
  const loc = useLocation()
  // console.log("location: ", loc)
  const claimantState = useClaimant().state
  const { ga4_userData } = useGa4()
  // console.log("claimantState: ", claimantState)
  useEffect(() => {
    ga4_userData({
      user_id: claimantState.webUserId ?? claimantState.caseReportId ?? '',
      is_customer: claimantState.webUserId != null,
      page_subcategory: loc.pathname
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc])
  return (
    <Switch>
      <Route exact path="/" component={RootPage} />
      <Route path="/init/:type?/:webuserid?" component={FrontInitPage} />

      {/**
       * Routes for every CaseType are defined separately for each CaseType.
       * - routes for the individual 'wizard' are defined in its own component. (e.g. CaseReportWizardME)
       */}
      <Route path="/ME">
        <CaseReportWizardME />
      </Route>
      <Route path="/CA">
        <CaseReportWizardCA />
      </Route>
      <Route path="/BA">
        <CaseReportWizardBA />
      </Route>
      <Route path="/PA">
        <CaseReportWizardPA />
      </Route>
      <Route path="/PL">
        <CaseReportWizardPL />
      </Route>
      <Route path="/TI">
        <CaseReportWizardTI />
      </Route>

      {
        /** Display debugging components if debuging components is enabled */
        isDebugRoutesEnabled && (
          <Route path="/debug" component={Routes_DevelopmentAndDebugging} />
        )
      }
      <Route path="*" component={PageNotFoundPage} />
    </Switch>
  )
}

const RootPage = () => {
  // on prod -> redirect to /leading-page
  return <ColplAppLayout body={<Home />} />
}

const PageNotFoundPage = () => {
  return <ColplAppLayout body={<ErrorPage />} />
}

export const RedirectToInit = (props: { caseType: CaseTypeType }) => {
  // XXX bude ztracen webUserId
  // YYY bude ztracena 'historie' -- nevíme, kam se máme vrátit ;)
  // pro funkci KPA 'toInit' viz 'routes.ts'
  return <Redirect to={`/init/${props.caseType}`} />
}
export const RedirectToRefresh = (props: { caseType: CaseTypeType }) => {
  // INFO zde bych chtel presmerovat na '/refresh' endpoint s tim,
  // ze se overi udaje z localStorage a dle toho se aplikace re - inicializuje
  // (pokud se jedná o rozpracovaný CaseReport, tak by se měl uživatel
  // dostat zpět na stejnou stránku, na které provedl refresh.)
  return <RedirectToInit {...props} />
}

export const CaseReportWizardEntryGate = (props: {
  caseType: CaseTypeType
  children: any
}) => {
  const caseType_context: CaseTypeType | null = useCaseType()
  //const location = useLocation()

  if (props.caseType === caseType_context) {
    // Correct caseType is selected to display this :)
    return props.children
  } else {
    if (caseType_context == null) {
      // No caseType set in the context --> re-initialize ;)
      // XXX bude ztracen webUserId
      // YYY bude ztracena 'historie' -- nevíme, kam se máme vrátit ;)
      // pro funkci KPA 'toInit' viz 'routes.ts'
      return <RedirectToRefresh caseType={props.caseType} />
    } else {
      // caseType_context != null && url is for different caseType => 404
      return <PageNotFoundPage />
    }
  }
}

const CaseReportRequiredRoute = (
  props: RouteNextProps & {
    caseReportNavigation: CaseReportNavigation
  }
) => {
  const caseReportIsPresent: boolean = useCaseReportIsPresent()
  if (caseReportIsPresent) {
    const path: string = props.path as string // nic jineho tam nesmime davat
    // is this route allowed?
    if (props.caseReportNavigation.isMoveTransitionAllowed(path)) {
      // then render the route as desired
      return <RouteNextVersion {...props} />
    } else {
      const lastAllowedStep =
        props.caseReportNavigation.getLastAllowedStep(path)
      return <Redirect to={lastAllowedStep.path} />
    }
  } else {
    const firstStep = props.caseReportNavigation.getFirstStep()
    return <Redirect to={firstStep.path} />
  }
}

type CaseReportNavStepCnf = {
  //index: number
  number: number | undefined | null
  path: string
  moveTransitionDisabled?(): boolean
  navBarHidden?(): boolean
}

interface CaseReportNavNumberStep {
  number: number
  isCurrent(): boolean
  moveTransitionAvailable(): boolean
  moveTo(): void
}

interface CaseReportNavStep extends CaseReportNavStepCnf {
  index: number
  /*
  available(): boolean
  goToNumber(number: number): void
  */
}

function getStepForPath(
  caseReportSteps: CaseReportNavStep[],
  path: string
): CaseReportNavStep | undefined {
  return caseReportSteps.find((value: CaseReportNavStepCnf) => {
    return value.path === path
  })
}

function groupStepsByNumbers(
  caseReportSteps: CaseReportNavStep[]
): CaseReportNavStep[][] {
  const numberGroups_map: Map<number, CaseReportNavStep[]> = toMap(
    caseReportSteps.filter((node) => node.number != null),
    (node) => node.number!
  )
  const numberGroups: CaseReportNavStep[][] = Array.from(
    numberGroups_map.values()
  )
  return numberGroups
}

function isStepBeforeOrEqual(
  caseReportSteps: CaseReportNavStep[],
  step: CaseReportNavStep,
  another: CaseReportNavStep
) {
  return step.index <= another.index
}

export type CaseReportNavbarProps = {
  currentPath?: string
  caseReportNavigation: CaseReportNavigation
}

const CaseReportNavbar: React.FunctionComponent<CaseReportNavbarProps> = (
  props: CaseReportNavbarProps
) => {
  const caseReportNavigation: CaseReportNavigation = props.caseReportNavigation

  const { t } = useTranslation()

  const isNavbarHidden: () => boolean =
    caseReportNavigation.currentStep?.navBarHidden ?? (() => false)

  let navbarItems: NavBarItem[]
  if (isNavbarHidden()) {
    navbarItems = []
  } else {
    // Group steps by numbers
    const stepGroups: CaseReportNavNumberStep[] =
      caseReportNavigation.getNumberedNavSteps()
    navbarItems = stepGroups.map(
      (group: CaseReportNavNumberStep, index: number): NavBarItem => {
        return {
          title: group.number.toString(),
          isCurrent: group.isCurrent(),
          isClickable: group.moveTransitionAvailable(),
          onClick: group.moveTo,
        }
      }
    )
  }

  return (
    <ColplAppSimpleTitleBar
      subTitle={t('appl.case' + caseReportNavigation.caseType)}
      items={navbarItems}
    />
  )
}

interface CaseReportNavigation {
  // Information for view
  caseType: CaseTypeType
  currentStep: CaseReportNavStep | undefined
  lastVisibleStep: CaseReportNavStep | null
  getStepForPath(path: string): CaseReportNavStep | undefined
  getNumberedNavSteps(): CaseReportNavNumberStep[]

  // To be used when making transitions
  transitionToNext(nextPath: string, currentPath: string): void
  transitionBack(path: string, currentPath: string): void

  isMoveTransitionAllowed(targetPath: string): boolean

  getFirstStep(): CaseReportNavStep
  getLastAllowedStep(targetPath: string): CaseReportNavStep
}

function useCaseReportNavigation(props: {
  caseType: CaseTypeType
  steps: CaseReportNavStepCnf[]
}): CaseReportNavigation {
  const transitions = useColplRouting()
  const ga4Context = useGa4Context()
  const { ga4_claimFormPath } = useGa4()

  // Wrap steps - add index to each item
  const steps: CaseReportNavStep[] = props.steps.map(
    (value: CaseReportNavStepCnf, index: number): CaseReportNavStep => {
      return { ...value, index: index }
    }
  )

  // Find out current step
  const currentPath: string = useLocation().pathname
  const currentStep: CaseReportNavStep | undefined = getStepForPath(
    steps,
    currentPath
  )

  // Last visible page and step is remembered in a state property
  const [lastVisibleStep, setLastVisibleStep] =
    useState<CaseReportNavStep | null>(null)

  /*
  const [lastSubmittedPage, setLastSubmittedPage] = useState<string | null>(null)
  const lastSubmittedStep: CaseReportNavStepCnf | null =
    lastSubmittedPage == null
      ? null
      : getStepForPath(props.steps, lastSubmittedPage) ?? null
  */

  // console.log("currentPath", currentPath)
  const { caseType, rest: pathRest }  = splitCurrentPath()
  const step: string = currentStep?.number?.toString() ?? ((pathRest.indexOf('thank-you') !== -1) ? 'confirmation' : '')

  const ga4Data = { case_type: caseType, step: step }
  useEffect(() => {
    ga4_claimFormPath(ga4Data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseType, step])

  useEffect(() => {
    ga4Context.updateGa4Data(ga4Data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseType, step])

  class CaseReportNavigationImpl implements CaseReportNavigation {
    readonly caseType: CaseTypeType
    readonly currentStep: CaseReportNavStep | undefined
    readonly lastVisibleStep: CaseReportNavStep
    readonly steps: CaseReportNavStep[]

    constructor(
      caseType: CaseTypeType,
      currentStep: CaseReportNavStep | undefined,
      lastVisibleStep: CaseReportNavStep | null,
      steps: CaseReportNavStep[]
    ) {
      this.caseType = caseType
      this.steps = steps
      this.currentStep = currentStep
      this.lastVisibleStep =
        lastVisibleStep != null ? lastVisibleStep : steps[0]
    }

    getStepForPath(path: string): CaseReportNavStep | undefined {
      return getStepForPath(this.steps, path)
    }

    getNumberedNavSteps(): CaseReportNavNumberStep[] {
      const stepGroups: CaseReportNavStep[][] = groupStepsByNumbers(this.steps)
      const navSteps = stepGroups.map(
        (
          values: CaseReportNavStep[],
          index: number
        ): CaseReportNavNumberStep => {
          // Contains step?
          const hasCurrentStep =
            this.currentStep != null && values.includes(this.currentStep)

          function getLastAvailableStep(): CaseReportNavStep {
            if (values.length > 1) {
              for (var i = values.length - 1; i > 0; i--) {
                const step = values[i]
                if (
                  step.moveTransitionDisabled == null ||
                  !step.moveTransitionDisabled()
                ) {
                  // not disabled --> return the step
                  return step
                }
                // else continue with search
              }
            }
            return values[0]
          }

          const targetStep: CaseReportNavStep = getLastAvailableStep()

          return {
            number: targetStep.number!, // non-numbered steps were already filtered out
            isCurrent: (): boolean => hasCurrentStep, // EHM...
            moveTransitionAvailable: (): boolean => {
              if (hasCurrentStep || lastVisibleStep == null) {
                // cannot move to itself or anywhere when lastVisibleStep is not defined
                return false
              } else {
                const isVisible: boolean = isStepBeforeOrEqual(
                  this.steps,
                  targetStep,
                  lastVisibleStep
                )
                return isVisible
              }
            },
            moveTo: (): void => {
              // ma se volat pouze, pokud 'moveTransitionAvailable'
              transitions.goToRoute(targetStep.path)
            },
          }
        }
      )
      return navSteps
    }

    transitionBack(path: string, currentPath: string): void {
      transitions.goToRoute(path)
    }
    transitionToNext(nextPath: string, currentPath: string): void {
      //setLastSubmittedPage(currentPath)
      const nextStep: CaseReportNavStep | undefined = getStepForPath(
        this.steps,
        nextPath
      )
      if (nextStep == null) {
        throw new Error(`Undefined transition to ${nextPath}`)
      }
      setLastVisibleStep(nextStep)
      transitions.goToRoute(nextPath)
    }

    isMoveTransitionAllowed(targetPath: string): boolean {
      const targetStep = this.getStepForPath(targetPath)
      if (targetStep == null) {
        // not found?
        return false
      }

      const isVisible: boolean = isStepBeforeOrEqual(
        this.steps,
        targetStep,
        this.lastVisibleStep
      )
      return isVisible
    }

    getFirstStep(): CaseReportNavStep {
      return this.steps[0]
    }

    getLastAllowedStep(targetPath: string): CaseReportNavStep {
      return this.lastVisibleStep
    }
  }
  return new CaseReportNavigationImpl(
    props.caseType,
    currentStep,
    lastVisibleStep,
    steps
  )

  function splitCurrentPath() {
    let caseType: string, rest: string

    const delimiter = '/'
    const myPath = _.trim(currentPath, delimiter)
    const delimiterIndex = myPath.indexOf(delimiter)

    if (delimiterIndex !== -1) {
      caseType = myPath.substring(0, delimiterIndex)
      rest = myPath.substring(delimiterIndex + delimiter.length)
    } else {
      caseType = myPath
      rest = ''
    }
    return { caseType, rest }
  }
}

export const CaseReportWizardME: React.FunctionComponent = () => {
  const transitions = useColplRouting()
  const { state: colState } = useClaimant()
  const { changeTreatmentExpensesType } = useTreatmentExpensesProvider()
  const loadedCaseReportResp = colState.loadedCaseReportResp
  //
  const isCaseReportWithTrip: boolean = !_.isEmpty(loadedCaseReportResp?.trip)

  const stepNodesME: CaseReportNavStepCnf[] = [
    {
      //index: 0,
      number: 1,
      path: '/ME/insurance',
    },
    {
      //index: 1,
      number: 1,
      path: '/ME/trip',
      moveTransitionDisabled: () => {
        return !isCaseReportWithTrip
      },
    },

    {
      //index: 2,
      number: 2,
      path: '/ME/claimant',
    },
    {
      //index: 3,
      number: 3,
      path: '/ME/health-problem',
    },
    {
      //index: 4,
      number: 4,
      path: '/ME/treatment-expenses',
      /*
      available: () => {
        return false
      },
      */
    },
    {
      //index: 5,
      number: 5,
      path: '/ME/other-data',
    },
    {
      //index: 6,
      number: 6,
      path: '/ME/overview',
    },
    {
      //index: 7,
      number: null,
      path: '/ME/thank-you',
      navBarHidden() {
        return true
      },
    },
  ]

  const caseReportNavigation: CaseReportNavigation = useCaseReportNavigation({
    caseType: CaseTypeEnum.ME,
    steps: stepNodesME,
  })

  return (
    <CaseReportWizardEntryGate caseType={CaseTypeEnum.ME}>
      <ColplAppLayout
        titleBar={
          <CaseReportNavbar caseReportNavigation={caseReportNavigation} />
        }
        body={
          <Switch>
            {/* V nové verzi react-router-dom se používá ne component, ale element ... tak jak to tu dělá KPA */}
            <PublicRoute path="/ME/insurance">
              <Insurance
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  //goNext: stepNodesME['/ME/insurance'].goNext,
                  /* */
                  goToTripPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/trip',
                      '/ME/insurance'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/claimant',
                      '/ME/insurance'
                    )
                  },
                }}
              />
            </PublicRoute>
            <CaseReportRequiredRoute
              path="/ME/trip"
              caseReportNavigation={caseReportNavigation}
            >
              <TripPage
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  goToChangeInsurance: () => {
                    caseReportNavigation.transitionBack(
                      '/ME/insurance',
                      '/ME/trip'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/claimant',
                      '/ME/trip'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/ME/claimant"
              caseReportNavigation={caseReportNavigation}
            >
              <ClaimantPage
                transitions={{
                  goBack: () => {
                    if (isCaseReportWithTrip) {
                      caseReportNavigation.transitionBack(
                        '/ME/trip',
                        '/ME/claimant'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/ME/insurance',
                        '/ME/claimant'
                      )
                    }
                  },

                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/health-problem',
                      '/ME/claimant'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/ME/health-problem"
              caseReportNavigation={caseReportNavigation}
            >
              <HealthProblemPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/ME/claimant',
                      '/ME/health-problem'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/treatment-expenses',
                      '/ME/health-problem'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            {/* OP / IP / OTH */}
            <CaseReportRequiredRoute
              path="/ME/treatment-expenses"
              caseReportNavigation={caseReportNavigation}
            >
              <TreatmentExpenses
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/ME/health-problem',
                      '/ME/treatment-expenses'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/other-data',
                      '/ME/treatment-expenses'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/ME/other-data"
              caseReportNavigation={caseReportNavigation}
            >
              <OtherDataPage
                transitions={{
                  goBack: () => {
                    const treatmentTypes =
                      loadedCaseReportResp?.caseME?.treatmentTypes
                    if (!!treatmentTypes?.length) {
                      changeTreatmentExpensesType(
                        treatmentTypes[treatmentTypes?.length - 1] ?? ''
                      )
                      caseReportNavigation.transitionBack(
                        '/ME/treatment-expenses',
                        '/ME/other-data'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/ME/health-problem',
                        '/ME/other-data'
                      )
                    }
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/overview',
                      '/ME/other-data'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/ME/overview"
              caseReportNavigation={caseReportNavigation}
            >
              <Overview
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/ME/other-data',
                      '/ME/overview'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/ME/thank-you',
                      '/ME/overview'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/ME/thank-you"
              caseReportNavigation={caseReportNavigation}
            >
              <ThankYou />
            </CaseReportRequiredRoute>

            {/* PageNotFoundPage - inside /ME */}
            <Route path="/ME/*">
              <ErrorPage />
            </Route>
          </Switch>
        }
      />
    </CaseReportWizardEntryGate>
  )
}

/**
 * CANCELLATION
 */
export const CaseReportWizardCA: React.FunctionComponent = () => {
  const transitions = useColplRouting()
  const { state: colState } = useClaimant()
  const loadedCaseReportResp = colState.loadedCaseReportResp
  //
  const isCaseReportWithTrip: boolean = !_.isEmpty(loadedCaseReportResp?.trip)

  const stepNodesCA: CaseReportNavStepCnf[] = [
    {
      //index: 0,
      number: 1,
      path: '/CA/insurance',
    },
    {
      //index: 1,
      number: 1,
      path: '/CA/trip',
      moveTransitionDisabled: () => {
        return !isCaseReportWithTrip
      },
    },

    {
      //index: 2,
      number: 2,
      path: '/CA/claimant',
    },
    {
      //index: 3,
      number: 3,
      path: '/CA/cancellation',
    },
    {
      //index: 4,
      number: 4,
      path: '/CA/cancellation-expenses',
    },
    {
      //index: 5,
      number: 5,
      path: '/CA/other-data',
    },
    {
      //index: 6,
      number: 6,
      path: '/CA/overview',
    },
    {
      //index: 7,
      number: null,
      path: '/CA/thank-you',
      navBarHidden() {
        return true
      },
    },
  ]

  const caseReportNavigation: CaseReportNavigation = useCaseReportNavigation({
    caseType: CaseTypeEnum.CA,
    steps: stepNodesCA,
  })

  return (
    <CaseReportWizardEntryGate caseType={CaseTypeEnum.CA}>
      <ColplAppLayout
        titleBar={
          <CaseReportNavbar caseReportNavigation={caseReportNavigation} />
        }
        body={
          <Switch>
            {/* V nové verzi react-router-dom se používá ne component, ale element ... tak jak to tu dělá KPA */}
            <PublicRoute path="/CA/insurance">
              <Insurance
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  //goNext: stepNodesME['/CA/insurance'].goNext,
                  /* */
                  goToTripPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/trip',
                      '/CA/insurance'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/claimant',
                      '/CA/insurance'
                    )
                  },
                }}
              />
            </PublicRoute>
            <CaseReportRequiredRoute
              path="/CA/trip"
              caseReportNavigation={caseReportNavigation}
            >
              <TripPage
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  goToChangeInsurance: () => {
                    caseReportNavigation.transitionBack(
                      '/CA/insurance',
                      '/CA/trip'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/claimant',
                      '/CA/trip'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/CA/claimant"
              caseReportNavigation={caseReportNavigation}
            >
              <ClaimantPage
                transitions={{
                  goBack: () => {
                    if (isCaseReportWithTrip) {
                      caseReportNavigation.transitionBack(
                        '/CA/trip',
                        '/CA/claimant'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/CA/insurance',
                        '/CA/claimant'
                      )
                    }
                  },

                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/cancellation',
                      '/CA/claimant'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/CA/cancellation"
              caseReportNavigation={caseReportNavigation}
            >
              <CancellationPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/CA/claimant',
                      '/CA/cancellation'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/cancellation-expenses',
                      '/CA/cancellation'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            {/* OP / IP / OTH */}
            <CaseReportRequiredRoute
              path="/CA/cancellation-expenses"
              caseReportNavigation={caseReportNavigation}
            >
              <CancellationExpensesPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/CA/cancellation',
                      '/CA/cancellation-expenses'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/other-data',
                      '/CA/cancellation-expenses'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/CA/other-data"
              caseReportNavigation={caseReportNavigation}
            >
              <OtherDataPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/CA/cancellation-expenses',
                      '/CA/other-data'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/overview',
                      '/CA/other-data'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/CA/overview"
              caseReportNavigation={caseReportNavigation}
            >
              <Overview
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/CA/other-data',
                      '/CA/overview'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/CA/thank-you',
                      '/CA/overview'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/CA/thank-you"
              caseReportNavigation={caseReportNavigation}
            >
              <ThankYou />
            </CaseReportRequiredRoute>

            {/* PageNotFoundPage - inside /CA */}
            <Route path="/CA/*">
              <ErrorPage />
            </Route>
          </Switch>
        }
      />
    </CaseReportWizardEntryGate>
  )
}

/**
 * BAGGAGE
 */
export const CaseReportWizardBA: React.FunctionComponent = () => {
  const transitions = useColplRouting()
  const { state: colState } = useClaimant()
  const loadedCaseReportResp = colState.loadedCaseReportResp
  //
  const isCaseReportWithTrip: boolean = !_.isEmpty(loadedCaseReportResp?.trip)

  const stepNodesBA: CaseReportNavStepCnf[] = [
    {
      //index: 0,
      number: 1,
      path: '/BA/insurance',
    },
    {
      //index: 1,
      number: 1,
      path: '/BA/trip',
      moveTransitionDisabled: () => {
        return !isCaseReportWithTrip
      },
    },

    {
      //index: 2,
      number: 2,
      path: '/BA/claimant',
    },
    {
      //index: 3,
      number: 3,
      path: '/BA/baggage',
    },
    {
      //index: 4,
      number: 4,
      path: '/BA/other-data',
    },
    {
      //index: 5,
      number: 5,
      path: '/BA/overview',
    },
    {
      //index: 6,
      number: null,
      path: '/BA/thank-you',
      navBarHidden() {
        return true
      },
    },
  ]

  const caseReportNavigation: CaseReportNavigation = useCaseReportNavigation({
    caseType: CaseTypeEnum.BA,
    steps: stepNodesBA,
  })

  return (
    <CaseReportWizardEntryGate caseType={CaseTypeEnum.BA}>
      <ColplAppLayout
        titleBar={
          <CaseReportNavbar caseReportNavigation={caseReportNavigation} />
        }
        body={
          <Switch>
            {/* V nové verzi react-router-dom se používá ne component, ale element ... tak jak to tu dělá KPA */}
            <PublicRoute path="/BA/insurance">
              <Insurance
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  //goNext: stepNodesBA['/BA/insurance'].goNext,
                  /* */
                  goToTripPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/trip',
                      '/BA/insurance'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/claimant',
                      '/BA/insurance'
                    )
                  },
                }}
              />
            </PublicRoute>
            <CaseReportRequiredRoute
              path="/BA/trip"
              caseReportNavigation={caseReportNavigation}
            >
              <TripPage
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  goToChangeInsurance: () => {
                    caseReportNavigation.transitionBack(
                      '/BA/insurance',
                      '/BA/trip'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/claimant',
                      '/BA/trip'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/BA/claimant"
              caseReportNavigation={caseReportNavigation}
            >
              <ClaimantPage
                transitions={{
                  goBack: () => {
                    if (isCaseReportWithTrip) {
                      caseReportNavigation.transitionBack(
                        '/BA/trip',
                        '/BA/claimant'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/BA/insurance',
                        '/BA/claimant'
                      )
                    }
                  },

                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/baggage',
                      '/BA/claimant'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/BA/baggage"
              caseReportNavigation={caseReportNavigation}
            >
              <Baggage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/BA/claimant',
                      '/BA/baggage'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/other-data',
                      '/BA/baggage'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/BA/other-data"
              caseReportNavigation={caseReportNavigation}
            >
              <OtherDataPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/BA/baggage',
                      '/BA/other-data'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/overview',
                      '/BA/other-data'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/BA/overview"
              caseReportNavigation={caseReportNavigation}
            >
              <Overview
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/BA/other-data',
                      '/BA/overview'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/BA/thank-you',
                      '/BA/overview'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/BA/thank-you"
              caseReportNavigation={caseReportNavigation}
            >
              <ThankYou />
            </CaseReportRequiredRoute>

            {/* PageNotFoundPage - inside /BA */}
            <Route path="/BA/*">
              <ErrorPage />
            </Route>
          </Switch>
        }
      />
    </CaseReportWizardEntryGate>
  )
}

/**
 * PERSONAL ACCIDENT
 */
export const CaseReportWizardPA: React.FunctionComponent = () => {
  const transitions = useColplRouting()
  const { state: colState } = useClaimant()
  const loadedCaseReportResp = colState.loadedCaseReportResp
  //
  const isCaseReportWithTrip: boolean = !_.isEmpty(loadedCaseReportResp?.trip)

  const stepNodesPA: CaseReportNavStepCnf[] = [
    {
      //index: 0,
      number: 1,
      path: '/PA/insurance',
    },
    {
      //index: 1,
      number: 1,
      path: '/PA/trip',
      moveTransitionDisabled: () => {
        return !isCaseReportWithTrip
      },
    },

    {
      //index: 2,
      number: 2,
      path: '/PA/claimant',
    },
    {
      //index: 3,
      number: 3,
      path: '/PA/accident',
    },
    {
      //index: 4,
      number: 4,
      path: '/PA/other-data',
    },
    {
      //index: 5,
      number: 5,
      path: '/PA/overview',
    },
    {
      //index: 6,
      number: null,
      path: '/PA/thank-you',
      navBarHidden() {
        return true
      },
    },
  ]

  const caseReportNavigation: CaseReportNavigation = useCaseReportNavigation({
    caseType: CaseTypeEnum.PA,
    steps: stepNodesPA,
  })

  return (
    <CaseReportWizardEntryGate caseType={CaseTypeEnum.PA}>
      <ColplAppLayout
        titleBar={
          <CaseReportNavbar caseReportNavigation={caseReportNavigation} />
        }
        body={
          <Switch>
            {/* V nové verzi react-router-dom se používá ne component, ale element ... tak jak to tu dělá KPA */}
            <PublicRoute path="/PA/insurance">
              <Insurance
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  //goNext: stepNodesPA['/PA/insurance'].goNext,
                  /* */
                  goToTripPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/trip',
                      '/PA/insurance'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/claimant',
                      '/PA/insurance'
                    )
                  },
                }}
              />
            </PublicRoute>
            <CaseReportRequiredRoute
              path="/PA/trip"
              caseReportNavigation={caseReportNavigation}
            >
              <TripPage
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  goToChangeInsurance: () => {
                    caseReportNavigation.transitionBack(
                      '/PA/insurance',
                      '/PA/trip'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/claimant',
                      '/PA/trip'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/PA/claimant"
              caseReportNavigation={caseReportNavigation}
            >
              <ClaimantPage
                transitions={{
                  goBack: () => {
                    if (isCaseReportWithTrip) {
                      caseReportNavigation.transitionBack(
                        '/PA/trip',
                        '/PA/claimant'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/PA/insurance',
                        '/PA/claimant'
                      )
                    }
                  },

                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/accident',
                      '/PA/claimant'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/PA/accident"
              caseReportNavigation={caseReportNavigation}
            >
              <Accident
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/PA/claimant',
                      '/PA/accident'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/other-data',
                      '/PA/accident'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/PA/other-data"
              caseReportNavigation={caseReportNavigation}
            >
              <OtherDataPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/PA/accident',
                      '/PA/other-data'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/overview',
                      '/PA/other-data'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/PA/overview"
              caseReportNavigation={caseReportNavigation}
            >
              <Overview
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/PA/other-data',
                      '/PA/overview'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PA/thank-you',
                      '/PA/overview'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/PA/thank-you"
              caseReportNavigation={caseReportNavigation}
            >
              <ThankYou />
            </CaseReportRequiredRoute>

            {/* PageNotFoundPage - inside /PA */}
            <Route path="/PA/*">
              <ErrorPage />
            </Route>
          </Switch>
        }
      />
    </CaseReportWizardEntryGate>
  )
}

/**
 * PERSONAL LIABILITY
 */
export const CaseReportWizardPL: React.FunctionComponent = () => {
  const transitions = useColplRouting()
  const { state: colState } = useClaimant()
  const loadedCaseReportResp = colState.loadedCaseReportResp
  //
  const isCaseReportWithTrip: boolean = !_.isEmpty(loadedCaseReportResp?.trip)

  const stepNodesPL: CaseReportNavStepCnf[] = [
    {
      //index: 0,
      number: 1,
      path: '/PL/insurance',
    },
    {
      //index: 1,
      number: 1,
      path: '/PL/trip',
      moveTransitionDisabled: () => {
        return !isCaseReportWithTrip
      },
    },

    {
      //index: 2,
      number: 2,
      path: '/PL/claimant',
    },
    {
      //index: 3,
      number: 3,
      path: '/PL/liability',
    },
    {
      //index: 4,
      number: 4,
      path: '/PL/other-data',
    },
    {
      //index: 5,
      number: 5,
      path: '/PL/overview',
    },
    {
      //index: 6,
      number: null,
      path: '/PL/thank-you',
      navBarHidden() {
        return true
      },
    },
  ]

  const caseReportNavigation: CaseReportNavigation = useCaseReportNavigation({
    caseType: CaseTypeEnum.PL,
    steps: stepNodesPL,
  })

  return (
    <CaseReportWizardEntryGate caseType={CaseTypeEnum.PL}>
      <ColplAppLayout
        titleBar={
          <CaseReportNavbar caseReportNavigation={caseReportNavigation} />
        }
        body={
          <Switch>
            {/* V nové verzi react-router-dom se používá ne component, ale element ... tak jak to tu dělá KPL */}
            <PublicRoute path="/PL/insurance">
              <Insurance
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  //goNext: stepNodesPL['/PL/insurance'].goNext,
                  /* */
                  goToTripPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/trip',
                      '/PL/insurance'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/claimant',
                      '/PL/insurance'
                    )
                  },
                }}
              />
            </PublicRoute>
            <CaseReportRequiredRoute
              path="/PL/trip"
              caseReportNavigation={caseReportNavigation}
            >
              <TripPage
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  goToChangeInsurance: () => {
                    caseReportNavigation.transitionBack(
                      '/PL/insurance',
                      '/PL/trip'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/claimant',
                      '/PL/trip'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/PL/claimant"
              caseReportNavigation={caseReportNavigation}
            >
              <ClaimantPage
                transitions={{
                  goBack: () => {
                    if (isCaseReportWithTrip) {
                      caseReportNavigation.transitionBack(
                        '/PL/trip',
                        '/PL/claimant'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/PL/insurance',
                        '/PL/claimant'
                      )
                    }
                  },

                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/liability',
                      '/PL/claimant'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/PL/liability"
              caseReportNavigation={caseReportNavigation}
            >
              <Liability
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/PL/claimant',
                      '/PL/liability'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/other-data',
                      '/PL/liability'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/PL/other-data"
              caseReportNavigation={caseReportNavigation}
            >
              <OtherDataPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/PL/liability',
                      '/PL/other-data'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/overview',
                      '/PL/other-data'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/PL/overview"
              caseReportNavigation={caseReportNavigation}
            >
              <Overview
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/PL/other-data',
                      '/PL/overview'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/PL/thank-you',
                      '/PL/overview'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/PL/thank-you"
              caseReportNavigation={caseReportNavigation}
            >
              <ThankYou />
            </CaseReportRequiredRoute>

            {/* PageNotFoundPage - inside /PL */}
            <Route path="/PL/*">
              <ErrorPage />
            </Route>
          </Switch>
        }
      />
    </CaseReportWizardEntryGate>
  )
}

/**
 * TICKET
 */
export const CaseReportWizardTI: React.FunctionComponent = () => {
  const transitions = useColplRouting()
  const { state: colState } = useClaimant()
  const loadedCaseReportResp = colState.loadedCaseReportResp
  //
  const isCaseReportWithTrip: boolean = !_.isEmpty(loadedCaseReportResp?.trip)

  const stepNodesTI: CaseReportNavStepCnf[] = [
    {
      //index: 0,
      number: 1,
      path: '/TI/insurance',
    },
    {
      //index: 1,
      number: 1,
      path: '/TI/trip',
      moveTransitionDisabled: () => {
        return !isCaseReportWithTrip
      },
    },

    {
      //index: 2,
      number: 2,
      path: '/TI/claimant',
    },
    {
      //index: 3,
      number: 3,
      path: '/TI/ticket',
    },
    {
      //index: 4,
      number: 4,
      path: '/TI/other-data',
    },
    {
      //index: 5,
      number: 5,
      path: '/TI/overview',
    },
    {
      //index: 6,
      number: null,
      path: '/TI/thank-you',
      navBarHidden() {
        return true
      },
    },
  ]

  const caseReportNavigation: CaseReportNavigation = useCaseReportNavigation({
    caseType: CaseTypeEnum.TI,
    steps: stepNodesTI,
  })

  return (
    <CaseReportWizardEntryGate caseType={CaseTypeEnum.TI}>
      <ColplAppLayout
        titleBar={
          <CaseReportNavbar caseReportNavigation={caseReportNavigation} />
        }
        body={
          <Switch>
            {/* V nové verzi react-router-dom se používá ne component, ale element ... tak jak to tu dělá KTI */}
            <PublicRoute path="/TI/insurance">
              <Insurance
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  //goNext: stepNodesTI['/TI/insurance'].goNext,
                  /* */
                  goToTripPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/trip',
                      '/TI/insurance'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/claimant',
                      '/TI/insurance'
                    )
                  },
                }}
              />
            </PublicRoute>
            <CaseReportRequiredRoute
              path="/TI/trip"
              caseReportNavigation={caseReportNavigation}
            >
              <TripPage
                transitions={{
                  goBack: () => {
                    transitions.redirectToLeadingPage()
                  },
                  goToChangeInsurance: () => {
                    caseReportNavigation.transitionBack(
                      '/TI/insurance',
                      '/TI/trip'
                    )
                  },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/claimant',
                      '/TI/trip'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/TI/claimant"
              caseReportNavigation={caseReportNavigation}
            >
              <ClaimantPage
                transitions={{
                  goBack: () => {
                    if (isCaseReportWithTrip) {
                      caseReportNavigation.transitionBack(
                        '/TI/trip',
                        '/TI/claimant'
                      )
                    } else {
                      caseReportNavigation.transitionBack(
                        '/TI/insurance',
                        '/TI/claimant'
                      )
                    }
                  },

                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/ticket',
                      '/TI/claimant'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>
            <CaseReportRequiredRoute
              path="/TI/ticket"
              caseReportNavigation={caseReportNavigation}
            >
              <Ticket
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/TI/claimant',
                      '/TI/ticket'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/other-data',
                      '/TI/ticket'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/TI/other-data"
              caseReportNavigation={caseReportNavigation}
            >
              <OtherDataPage
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/TI/ticket',
                      '/TI/other-data'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/overview',
                      '/TI/other-data'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/TI/overview"
              caseReportNavigation={caseReportNavigation}
            >
              <Overview
                transitions={{
                  goBack: () => {
                    caseReportNavigation.transitionBack(
                      '/TI/other-data',
                      '/TI/overview'
                    )
                  },
                  goToNextPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/thank-you',
                      '/TI/overview'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            <CaseReportRequiredRoute
              path="/TI/thank-you"
              caseReportNavigation={caseReportNavigation}
            >
              <ThankYou
                transitions={{
                  goBack: () => { },
                  goToClaimantPage: () => {
                    caseReportNavigation.transitionToNext(
                      '/TI/claimant',
                      '/TI/thank-you'
                    )
                  },
                }}
              />
            </CaseReportRequiredRoute>

            {/* PageNotFoundPage - inside /TI */}
            <Route path="/TI/*">
              <ErrorPage />
            </Route>
          </Switch>
        }
      />
    </CaseReportWizardEntryGate>
  )
}

/*
export const RouterAppME = () => {
  return (
    <Router>
      <Header />
      <TitleBar />
      <Switch>
        <Route path="/ME/insurance" component={Insurance} />
        <PrivateRoute path="/ME/trip" component={Trip} />
        <PrivateRoute path="/ME/claimant" component={ClaimantPage} />
        <PrivateRoute path="/ME/health-problem" component={HealthProblemPage} />

        <PrivateRoute
          path="/ME/treatment-expenses"
          component={TreatmentExpenses}
        />
        <PrivateRoute path="/ME/other-data" component={OtherDataPage} />
        <PrivateRoute path="/ME/overview" component={Overview} />
        <Route path="/ME/thank-you" component={ThankYou} />

        <Route path="*" component={ErrorPage} />
      </Switch>
    </Router>
  )
}
*/

// https://v5.reactrouter.com/web/example/route-config
// https://stackoverflow.com/questions/58203599/nested-switch-does-not-work-in-react-router
const Routes_DevelopmentAndDebugging = () => (
  <ColplAppLayout
    body={
      <div>
        <h2>Debugging Components</h2>
        <ul>
          <li>
            <Link to="/debug/test">Test page</Link>
          </li>
          <li>
            <Link to="/debug/test-formik">Test formik</Link>
          </li>
          <li>
            <Link to="/debug/insurance">InsuranceForm</Link>
          </li>
          <li>
            <Link to="/debug/trip">TripForm</Link>
          </li>
          <li>
            <Link to="/debug/claimant">ClaimantForm</Link>
          </li>
          <li>
            <Link to="/debug/health-problem">HealthProblemForm</Link>
          </li>
          <li>
            <Link to="/debug/treatment-expenses">TreatmentExpensesForm</Link>
          </li>
          <li>
            <Link to="/debug/other-data">OtherDataForm</Link>
          </li>
          <li>
            <Link to="/debug/cancellation">CancellationForm</Link>
          </li>
          <li>
            <Link to="/debug/cancellation-expenses">CancellatioExpensesForm</Link>
          </li>
          <li>
            <Link to="/debug/baggage">BaggageForm</Link>
          </li>
          <li>
            <Link to="/debug/accident">AccidentForm</Link>
          </li>
          <li>
            <Link to="/debug/liability">LiabilityForm</Link>
          </li>
          <li>
            <Link to="/debug/ticket">TicketForm</Link>
          </li>
          <li>
            <Link to="/debug/thank-you">ThankYouForm</Link>
          </li>
        </ul>
        <Switch>
          <Route path="/debug/test" component={TestForm} />
          <Route path="/debug/test-formik" component={FormikDebug} />
          <Route path="/debug/baggage" component={BaggageDebug} />
          <Route path="/debug/health-problem" component={HealthProblemDebug} />
          <Route path="/debug/claimant" component={ClaimantDebug} />
          <Route path="/debug/other-data" component={OtherDataDebug} />
          <Route path="/debug/insurance" component={InsuranceDebug} />
          <Route path="/debug/trip" component={TripDebug} />
          <Route path="/debug/cancellation" component={CancellationDebug} />
          <Route
            path="/debug/cancellation-expenses"
            component={CancellationExpensesDebug}
          />
          <Route
            path="/debug/treatment-expenses"
            component={TreatmentExpensesDebug}
          />
          <Route path="/debug/accident" component={AccidentDebug} />
          <Route path="/debug/liability" component={LiabilityDebug} />
          <Route path="/debug/ticket" component={TicketDebug} />
          <Route path="/debug/thank-you" component={ThankYouPageDebug} />
        </Switch>
      </div>
    }
  />
)

/*
export const RouterAppOld = () => (
  <Router>
    <Header />
    <TitleBar />
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/init/:type?/:webuserid?" component={FrontInitPage} />
      <Route path="/insurance" component={Insurance} />
      <PrivateRoute path="/trip" component={Trip} />
      <PrivateRoute path="/claimant" component={ClaimantPage} />
      <PrivateRoute path="/accident" component={Accident} />
      <PrivateRoute path="/liability" component={Liability} />
      <PrivateRoute path="/ticket" component={Ticket} />
      <PrivateRoute path="/health-problem" component={HealthProblemPage} />
      <PrivateRoute path="/cancellation" component={CancellationPage} />
      <PrivateRoute path="/cancellation-expenses" component={CancellationExpensesPage} />
      <PrivateRoute path="/treatment-expenses" component={TreatmentExpenses} />
      <PrivateRoute path="/ba" component={Baggage} />
      <PrivateRoute path="/other-data" component={OtherDataPage} />
      <PrivateRoute path="/overview" component={Overview} />
      <Route path="/thank-you" component={ThankYou} />

      {isDebugRoutesEnabled && (
        <Route path="/debug" component={Routes_DevelopmentAndDebugging} />
      )}
      <Route path="*" component={ErrorPage} />
    </Switch>
  </Router>
)
*/
